module.exports = __webpack_public_path__ + "52f2d980edbc63d5812cbb4dbf9daf67.svg";